import React, { useState } from 'react';
import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import House from '../../Assets/images/house.png';

function PurchaseSummaryModal({ open, handleClose, handleBack, property, purchaseData, onConfirm }) {
  const [agreed, setAgreed] = useState(false);

  if (!property || !purchaseData) return null;

  const units = purchaseData.units || 2;
  const priceRaw = property.unitPrice ? Number(property.unitPrice) : 0;
  const subTotal = units * priceRaw;

  // 1.5% processing fee
  const processingFee = subTotal * 0.015;
  const total = subTotal + processingFee;

  const formatCurrency = (val) => new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN', minimumFractionDigits: 0 }).format(val);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '24px',
          padding: '24px',
          backgroundColor: '#FAFAFB',
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-3">
          <IconButton onClick={handleBack} size="small">
            <ArrowBackIcon fontSize="small" style={{ color: '#1A1A1B' }} />
          </IconButton>
          <span className="font-bold text-[14px] text-back-color2">Back</span>
        </div>
        <div
          onClick={handleClose}
          className="w-8 h-8 rounded-full bg-[#1A1A1B] flex items-center justify-center cursor-pointer hover:bg-gray-800"
        >
          <CloseIcon fontSize="small" style={{ color: 'white' }} />
        </div>
      </div>

      {/* Property Summary Card */}
      <div className="bg-white rounded-2xl p-3 flex gap-4 items-center mb-6 shadow-sm border border-gray-100">
        <div className="w-[80px] h-[80px] rounded-xl overflow-hidden flex-shrink-0">
          <img src={property.image || House} alt={property.title} className="w-full h-full object-cover" />
        </div>
        <div className="flex-1">
          <div className="flex justify-between items-start mb-1">
            <h3 className="font-bold text-[14px] text-back-color2 leading-tight">{property.title}</h3>
            <span className={`text-[10px] px-2 py-0.5 rounded text-white ${property.typeColor || 'bg-[#007BFF]'}`}>
              {property.type}
            </span>
          </div>
          <p className="text-[10px] text-gray-400 mb-3">{formatCurrency(priceRaw)} per unit</p>
          <p className="text-[10px] text-gray-500">
            AVAILABLE : <span className="font-bold text-black">{property.unitsLeft || 0} UNITS</span>
          </p>
        </div>
      </div>

      {/* Payment Breakdown */}
      <div className="bg-white rounded-2xl p-5 mb-8 shadow-sm border border-gray-100">
        <p className="text-[12px] font-bold text-back-color2 mb-4">Payment Breakdown</p>

        <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-50">
          <span className="text-[12px] text-gray-400">{units} unit x {formatCurrency(priceRaw)}</span>
          <span className="font-bold text-[14px] text-back-color2">{formatCurrency(subTotal)}</span>
        </div>

        <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-50">
          <span className="text-[12px] text-gray-400">Processing fee (1.5%)</span>
          <span className="font-bold text-[14px] text-back-color2">{formatCurrency(processingFee)}</span>
        </div>

        <div className="flex justify-between items-center mt-2">
          <span className="text-[12px] text-gray-400">Total</span>
          <span className="font-bold text-[16px] text-back-color2">{formatCurrency(total)}</span>
        </div>
      </div>

      {/* Terms Checkbox */}
      <div
        className="flex items-start gap-2 mb-6 cursor-pointer"
        onClick={() => setAgreed(!agreed)}
      >
        {agreed
          ? <CheckBoxIcon style={{ color: '#00BC67', fontSize: '20px', marginTop: '2px' }} />
          : <CheckBoxOutlineBlankIcon style={{ color: '#00BC67', fontSize: '20px', marginTop: '2px' }} />
        }
        <p className="text-[10px] text-gray-500 leading-tight">
          I agree to the Zouse Investment Terms and understand that real estate investments carry risk
        </p>
      </div>

      {/* Submit Button */}
      <button
        onClick={onConfirm}
        disabled={!agreed}
        className={`w-full font-bold py-3.5 rounded-xl text-[14px] transition-colors ${agreed
            ? 'bg-primary-color text-white hover:bg-[#00a359]'
            : 'bg-[#E6F8F0] text-[#00BC67] opacity-60 cursor-not-allowed'
          }`}
      >
        Review Order
      </button>

    </Dialog>
  );
}

export default PurchaseSummaryModal;
